import {StatusChip} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/pages/common/StatusChip';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React, {useMemo} from 'react';
// @todo: Migrate to 'Link' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Link} from 'react-router-dom';

import {TraceItemProps} from '../types';
import {buildCallRoute} from '../utils';
import {CallItemMetrics} from './CallItemMetrics';

export const TraceItem: React.FC<TraceItemProps> = ({
  callId,
  spanName,
  displayName,
  startedAt,
  latency,
  status,
  tokens,
  cost,
  userId,
  entityName,
  projectName,
}) => {
  const route = useMemo(
    () => buildCallRoute(callId, 'traces', entityName, projectName),
    [callId, entityName, projectName]
  );

  return (
    <Tailwind>
      <Link
        to={route}
        className="flex min-h-[52px] items-center gap-12 px-20 py-12 hover:bg-moon-50">
        {/* Left: Status + Name (flexible) */}
        <div className="flex min-w-0 flex-1 items-center gap-12">
          <StatusChip value={status} iconOnly />
          <div className="min-w-0 flex-1">
            <div className="truncate font-medium text-moon-900">
              {displayName || spanName}
            </div>
          </div>
        </div>

        {/* Right: Metrics columns */}
        <CallItemMetrics
          cost={cost}
          tokens={tokens}
          latency={latency}
          timestamp={startedAt}
          userId={userId}
        />
      </Link>
    </Tailwind>
  );
};
